<p>{{ 'productsStep.bkgTripInfoPassengers.passengersTransfer' | translate }}</p>
<div class="passenger-counter__list">
  <div class="passenger-counter">
    <div class="passenger-counter__icon">
      <img src="assets/images/passengers-out.svg" />
    </div>

    <div class="passenger-counter__content">
      <div class="passenger-counter__block-with-help">
        <span class="passenger-counter__title passenger-counter__title-help">{{
          'productsStep.bkgTripInfoPassengers.passengersIn' | translate
        }}</span>
        <div
          [attr.data-text]="
            'productsStep.bkgTripInfoPassengers.passengersTooltip' | translate
          "
          class="tooltip-bottom"
        >
          <img src="assets/images/icons/info.svg" />
        </div>
      </div>
      <span class="passenger-counter__extra">
        {{ 'common.included' | translate }}
      </span>
    </div>

    <div class="passenger-counter__counter">
      <button
        (click)="onClickRemoveInPassenger()"
        class="passenger-counter__btn"
      >
        <img src="assets/images/icons/minus-circle.svg" />
      </button>
      <!-- <span class="passenger-counter__number">{{ inPassengers }}</span> -->
      <input
        (change)="updateInpassenger()"
        [(ngModel)]="inPassengers"
        type="tel"
        maxlength="1"
        max="maxPassengers"
        class="passenger-counter__title passenger-counter__title-help passenger-counter__input"
        [class.passenger-counter__input-big]="inPassengers >= 10"
      />
      <button
        (click)="onClickAddInPassenger()"
        class="passenger-counter__btn"
        [class.passenger-counter__btn-disabled]="inPassengers === maxPassengers"
      >
        <img src="assets/images/icons/plus-circle.svg" />
      </button>
    </div>
  </div>
  <div class="passenger-counter">
    <div class="passenger-counter__icon">
      <img src="assets/images/passengers-in.svg" />
    </div>

    <div class="passenger-counter__content">
      <span class="passenger-counter__title">
        {{ 'productsStep.bkgTripInfoPassengers.passengersOut' | translate }}
      </span>
      <span class="passenger-counter__extra">
        {{ 'common.included' | translate }}
      </span>
    </div>

    <div class="passenger-counter__counter">
      <button
        (click)="onClickRemoveOutPassenger()"
        class="passenger-counter__btn"
      >
        <img src="assets/images/icons/minus-circle.svg" />
      </button>
      <!-- <span class="passenger-counter__number">{{ outPassengers }}</span> -->
      <input
        (change)="updateOutpassenger()"
        [(ngModel)]="outPassengers"
        type="tel"
        maxlength="1"
        max="maxPassengers"
        class="passenger-counter__title passenger-counter__title-help passenger-counter__input"
        [class.passenger-counter__input-big]="outPassengers >= 10"
      />
      <button
        (click)="onClickAddOutPassenger()"
        class="passenger-counter__btn"
        [class.passenger-counter__btn-disabled]="
          outPassengers === maxPassengers
        "
      >
        <img src="assets/images/icons/plus-circle.svg" />
      </button>
    </div>
  </div>
</div>
